import ReactGA from "react-ga4";

// Inicializa Google Analytics con tu ID de seguimiento
ReactGA.initialize("G-42R529VY1K");

/**
 * Obtiene la ubicación del usuario.
 * @returns {Promise<string>} Una promesa que resuelve a una cadena con la latitud y longitud.
 */
const getLocation = () => {
    return new Promise((resolve, reject) => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    resolve(`Lat: ${latitude}, Lon: ${longitude}`);
                },
                (error) => {
                    reject("Ubicación no disponible");
                }
            );
        } else {
            reject("Geolocalización no soportada");
        }
    });
};

/**
 * Registra un evento en Google Analytics con información opcional de ubicación.
 * @param {string} category - La categoría del evento.
 * @param {string} action - La acción del evento.
 * @param {string} label - La etiqueta del evento.
 */
export const logEvent = async (category, action, label) => {
    try {
        const location = await getLocation(); // Obtiene la ubicación del usuario
        ReactGA.event({
            category,
            action,
            label: `${label} | Ubicación: ${location}`,
        });
    } catch (err) {
        ReactGA.event({
            category,
            action,
            label: `${label} | Ubicación: No disponible`,
        });
    }
};

